import { useState } from 'react'
import { useToast } from '@chakra-ui/react'
import { doc, updateDoc } from 'firebase/firestore'
import { ExposureData } from '../../../../../types/FirestoreUser'
import { getEffectiveServices } from '../../../../../utils/firebaseServiceContext'

export const useEnvironmentalSave = (uid: string) => {
  const [isSaving, setIsSaving] = useState(false)
  const toast = useToast()

  const saveExposureHistory = async (
    exposureData: ExposureData[],
    fieldName: string
  ) => {
    setIsSaving(true)
    
    // Validate exposure data
    const invalidEntries = exposureData.filter(
      (entry) =>
        entry.ageDiagnosed !== undefined &&
        entry.ageDiagnosed !== null &&
        entry.ageEnded !== null &&
        entry.ageEnded < entry.ageDiagnosed
    )

    if (invalidEntries.length > 0) {
      const invalidConditions = invalidEntries.map((entry) => entry.condition)
      toast({
        title: 'Error',
        description: `The following Known Toxic Exposures have incorrect values: ${invalidConditions.join(
          ', '
        )}. Age at end of exposure cannot be less than age at start of exposure.`,
        status: 'error',
        duration: 10000,
        isClosable: true,
      })
      setIsSaving(false)
      return
    }

    if (!uid) {
      alert('Not logged in!')
      setIsSaving(false)
      return
    }
    
    const userRef = doc(getEffectiveServices().firestore, 'users', uid)
    await updateDoc(userRef, {
      [`medicalDetails.${fieldName}`]: exposureData,
    })
    
    setIsSaving(false)
    toast({
      title: 'Success',
      description: 'Your environmental exposure data has been successfully saved.',
      status: 'success',
      duration: 5000,
      isClosable: true,
    })
  }

  return {
    isSaving,
    saveExposureHistory,
  }
}

export default useEnvironmentalSave
